import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

type StoredToken = {
  AccessToken?: string;
};

export type PatchWithdrawPreventionPayload = {
  user_id: string;
  is_prevent_from_withdraw: boolean;
};

export type PatchWithdrawPreventionResponse = {
  message?: string;
  [key: string]: unknown;
} | null;

const patchWithdrawPrevention = async ({
  user_id,
  is_prevent_from_withdraw,
}: PatchWithdrawPreventionPayload): Promise<PatchWithdrawPreventionResponse> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.patch(
    API_ROUTES.USER_WITHDRAW_PREVENTION.replace("{user_id}", user_id),
    { is_prevent_from_withdraw },
  );

  return response?.data ?? null;
};

export const usePatchWithdrawPrevention = () =>
  useMutation<
    PatchWithdrawPreventionResponse,
    Error,
    PatchWithdrawPreventionPayload
  >({
    mutationKey: ["patchWithdrawPrevention"],
    mutationFn: patchWithdrawPrevention,
  });
